import React from 'react';
//gatsby
import { useStaticQuery, graphql } from 'gatsby';
//router
import { useLocation } from '@reach/router';
//styles
import styled from 'styled-components';
import { rem } from 'polished';
import vars from 'components/styles/varss';
//components
import Heading from 'components/ui/heading';
import Button from 'components/ui/button';
//asset
import bg from '../../assets/images/cta-shape.svg';

//styled
const CtaWrap = styled.div`
  background-color: ${vars.colors.paleCapri};
  padding: ${rem('40px')};
  border-radius: 12px;
  margin-top: ${rem('60px')};
  margin-bottom: ${rem('60px')};
  @media (min-width: ${vars.media.lgMin}) {
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-position: center left 100%;
    background-size: contain;
  }
  .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
    .texts {
      max-width: 490px;
      h4 {
        margin-bottom: ${rem('10px')};
      }
    }
  }
`;

const Cta = () => {

  //graphql query
  const data = useStaticQuery(graphql`
    query {
      wp {
        blogCtas {
          getDemoCta {
            getDemoCTAButtonText
            getDemoCTAButtonUrl
            getDemoCTAText
            getDemoCTATitle
          }
        }
      }
    }
  `);

  //get params
  const location = useLocation();
  const search = location.search;

  return (
    <CtaWrap>
      <div className="inner">
        <div className="texts">
          <Heading as="h4" heading4>{data.wp.blogCtas.getDemoCta.getDemoCTATitle}</Heading>
          <p>{data.wp.blogCtas.getDemoCta.getDemoCTAText}</p>
        </div>
        <Button to={`${data.wp.blogCtas.getDemoCta.getDemoCTAButtonUrl}${search}`} green lg>{data.wp.blogCtas.getDemoCta.getDemoCTAButtonText}</Button>
      </div>
    </CtaWrap>
  );
}

export default Cta;